import { Box, Button, TextField } from '@mui/material';
import React, { SyntheticEvent, useRef } from 'react';

interface SingleTermSearchProps {
    onSubmit: (term: string) => void;
}

export const SingleTermSearch: React.FunctionComponent<SingleTermSearchProps> = ({ onSubmit, children }) => {
    const inputRef = useRef<HTMLInputElement>();

    const onSub = (evt: SyntheticEvent) => {
        evt.preventDefault();
        if (!inputRef.current) {
            return;
        }
        onSubmit(inputRef.current.value);
    };

    return (
        <form onSubmit={onSub}>
            <Box display='flex' mb={1}>
                <Box flexGrow={1} mr={1}>
                    <TextField
                        name='term'
                        label='Search Term'
                        variant='outlined'
                        size='small'
                        inputRef={inputRef}
                        fullWidth
                    />
                </Box>
                <Button variant='contained' color='primary' type='submit'>
                    Search
                </Button>
                {children}
            </Box>
        </form>
    );
};
